import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import Routes from '../../navigation/Routes';
import { DIBELS8_APPLICATION_SID } from '../../../constants/reading/CommonConstants';
import { BASE_URLS } from '../../../constants/reading/ApiConstants';
import Spinner from '../../../components/spinner/Spinner';
import { getUrlParams } from '../../../utils/shared/urlUtils';
import config from '../../../configs/reading';

const AppLayout = ({
    isDataFetched,
    currentSchoolId,
    studentIds,
    currentClassId,
    currentDistrictId,
    hasBurstLicense,
    fetchInterps,
    fetchInterventions,
    fetchStudentGoals,
    fetchStudentResults,
    fetchR3DInterps,
    location,
    licensingInfo,
    fetchEnrollmentData,
    updateEnrollmentUrl,
    fetchPdfAvailability,
    isEnrollmentDataExists,
    loadDemoData,
}) => {
    const { applicationSid } = getUrlParams(location);

    useEffect(() => {
        if (!isDataFetched) {
            // getting search params here to avoid stale data after page reloading
            const { district, school, classe, period, burstGroupUid } = getUrlParams(location);
            fetchEnrollmentData(district, school, classe, period, burstGroupUid);
        }
        loadDemoData();
        fetchPdfAvailability();
    }, []);

    useEffect(() => {
        if (isDataFetched) {
            updateEnrollmentUrl();
        }
    }, [isDataFetched]);

    useEffect(() => {
        if (isDataFetched && currentClassId && !isEmpty(studentIds)) {
            fetchInterventions(hasBurstLicense);
            fetchStudentGoals();
            fetchStudentResults();
        }
    }, [currentDistrictId, currentClassId]); // currentDistrictId is needed in deps for SPA user

    useEffect(() => {
        if (isDataFetched && currentSchoolId && currentClassId) {
            fetchInterps();
            fetchR3DInterps(BASE_URLS.BASE_URL, applicationSid || DIBELS8_APPLICATION_SID);
        }
    }, [currentDistrictId, currentSchoolId]);
    if (!isDataFetched && !isEnrollmentDataExists) return <Spinner />;

    return <Routes licensingInfo={licensingInfo} config={config} />;
};

AppLayout.defaultProps = {
    fetchEnrollmentData: () => {},
    updateEnrollmentUrl: () => {},
    fetchInterps: () => {},
    fetchStudentResults: () => {},
    fetchR3DInterps: () => {},
    fetchInterventions: () => {},
    fetchStudentGoals: () => {},
    fetchPdfAvailability: () => {},
    loadDemoData: () => {},
    isDataFetched: false,
    isEnrollmentDataExists: false,
    currentClassId: null,
    currentSchoolId: null,
    currentDistrictId: null,
    studentIds: [],
    hasBurstLicense: false,
    licensingInfo: [],
};

AppLayout.propTypes = {
    fetchEnrollmentData: PropTypes.func,
    updateEnrollmentUrl: PropTypes.func,
    fetchInterps: PropTypes.func,
    fetchStudentResults: PropTypes.func,
    fetchR3DInterps: PropTypes.func,
    fetchInterventions: PropTypes.func,
    fetchStudentGoals: PropTypes.func,
    fetchPdfAvailability: PropTypes.func,
    loadDemoData: PropTypes.func,
    isDataFetched: PropTypes.bool,
    isEnrollmentDataExists: PropTypes.bool,
    currentClassId: PropTypes.string,
    currentSchoolId: PropTypes.string,
    location: PropTypes.object.isRequired,
    currentDistrictId: PropTypes.string,
    studentIds: PropTypes.arrayOf(PropTypes.string),
    hasBurstLicense: PropTypes.bool,
    licensingInfo: PropTypes.array,
};

export default AppLayout;
